import type { VersionRow } from '../types'

/**
 * The active discovery cycle a version-scoped action targets: first ACTIVE,
 * else first IN_PROGRESS, else `rows[0]` — the SAME resolution TASK-A30F4433
 * uses. Lifted from `BulkImportPanel` when ticket generation became its second
 * caller (CR-BUILD-BOARD-EPICS-2026-09-26); the body is unchanged.
 */
export function activeVersionOf(rows: readonly VersionRow[]): VersionRow | null {
  if (rows.length === 0) return null
  return rows.find((r) => r.status === 'ACTIVE') ?? rows.find((r) => r.status === 'IN_PROGRESS') ?? rows[0] ?? null
}
